import { useNavigate } from 'react-router-dom';
import { GlobalAction } from '../interfaces/allowed-actions';
import { allowedActionsService } from '../services/allowed-actions.service';

export function useAllowedActionsGuard({
  actionType,
  navigationRoute,
  queryParams
}: {
  actionType: GlobalAction;
  navigationRoute: string;
  queryParams: Record<string, string>;
}) {
  const navigate = useNavigate();

  const executeAllowedActionsGuard = () => {
    const action = allowedActionsService.getActionByType.bind(allowedActionsService)(actionType);

    if (action && !action.is_disabled) {
      return true;
    }

    navigate({
      pathname: navigationRoute,
      search: `?${new URLSearchParams(queryParams)}`
    });

    return false;
  };

  return {
    executeAllowedActionsGuard
  };
}
